<template>
  <div id="figer-page">
    <v-snackbar
      class="snack-tab"
      v-model="snackbar"
      top
      centered
      :timeout="timeout"
      :color="snackbarColor"
    >
      <span>
        {{ text }}
      </span>

      <v-btn color="white" text @click="snackbar = false">
        <v-icon class="fas fa-times"></v-icon>
      </v-btn>
    </v-snackbar>
    <span class="figer-title"> {{ cardTitle }}</span>

    <v-tabs class="tab-select-bar" grow v-model="active_tab">
      <v-tab v-for="tab of tabs" :key="tab.id">
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <div v-if="user != null && active_tab == 0" class="tab-fige">
      <SolQTable v-bind:user="this.user" v-on:message-response="toaster" />
    </div>
    <div v-if="user != null && active_tab == 1" class="tab-fige">
      <SolFssTable v-bind:user="this.user" v-on:message-response="toaster" />
    </div>
    <div v-if="user != null && active_tab == 2" class="tab-fige">
      <SolFscTable v-bind:user="this.user" v-on:message-response="toaster" />
    </div>
    <div v-if="user != null && active_tab == 3" class="tab-fige">
      <SolCdecTable v-bind:user="this.user" v-on:message-response="toaster" />
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import SolQTable from '@/components/Table/FigerStockage';
import SolFssTable from '@/components/Table/FigerTranfert';
import SolFscTable from '@/components/Table/FigerVentes';
import SolCdecTable from '@/components/Table/FigerDecotes';

export default {
  name: 'figer',
  components: {
    SolQTable,
    SolFssTable,
    SolFscTable,
    SolCdecTable,
  },

  data: function () {
    return {
      cardTitle: 'Après : Figer',
      user: null,
      currentUserId: null,
      currentTime: null,
      currentUserSuperAdmin: false,
      snackbar: false,
      text: '',
      timeout: 9000,
      snackbarColor: '',
      active_tab: 0,
      tabs: [
        { id: 0, name: 'Stockage' },
        { id: 1, name: 'Transferts' },
        { id: 2, name: 'Ventes' },
        { id: 3, name: 'Décotes' },
      ],
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      // clock updates for import and optimization elapsed time
      return this.$store
        .dispatch('fetchUserInfos')
        .then((userInfos) => {
          window.setInterval(() => {
            this.update();
          }, 1000);
          this.user = userInfos;
          this.currentTime = new Date();
          this.currentUserId = this.$store.state.userId;
          this.currentUserSuperAdmin = userInfos.isSuperAdmin;
        })
        .catch((e) => {
        });
    },
    update() {
      this.currentTime = new Date();
    },
    toaster(message, status, flag) {
      this.snackbarColor = status == 1 ? 'success' : 'red';
      this.snackbar = flag;
      this.text = message;
    },
  },
};
</script>

<style lang="scss" scoped>
#figer-page {
  display: block;
  height: calc(100vh - 64px);
  overflow-y: scroll;
  position: relative;

  #add-user-grid,
  #add-site-grid {
    display: inline-block;
    height: auto;
  }
  .grid-container {
    display: inline-block;
    margin-bottom: 48px;
  }
}

.figer-title {
  text-decoration: none;
  background-color: #f8a331 !important;
  color: white;
  text-align: center;
  letter-spacing: 0.03125rem;
  border: none;
  border-radius: 0.125rem;
  display: inline-block;
  height: 2.25rem;
  line-height: 2.25rem;
  margin-top: 5%;
  padding: 0 1rem !important;
  text-transform: uppercase;
  font-size: 1rem;
}

.tab-fige {
  margin-bottom: 60px;
  margin-left: 10px;
  margin-top: 10px;
}

.tab-search {
  margin-bottom: 10px;
}

.scdf-yellow {
  margin-top: 10px;
}

.snack-tab {
  margin-top: 65px;
}
</style>